export { default } from './TouchFeedback';


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rmc-feedback@2.0.0@rmc-feedback/es/index.js
// module id = 99
// module chunks = 0